import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import debounce from 'lodash/debounce';

const loadMasonry = require('bundle-loader?lazy&name=[name]!masonry-layout');

const loadFlickity = require('bundle-loader?lazy&name=[name]!flickity');

export default el => {
    const dom = $(el);
    const items = dom.find('[data-item]');
    const modalImages = items.find('img').clone();
    let modalClose;
    let hasModal = false;
    let debouncedResize;
    let modalHidden = true;
    let modalItems;
    let flkty;
    let msnry;
    let modal;
    let modalInner;
    let modalOuter;

    const show = () => {
        if (modalHidden) {
            modalHidden = false;
            TweenMax.set(modal.get(0), { display: 'block', opacity: 0 });

            TweenMax.set(modalOuter.get(0), { opacity: 0 });

            TweenMax.killTweensOf([modal.get(0), modalOuter.get(0)]);

            TweenMax.to(modal.get(0), 0.3, { opacity: 1 });
            TweenMax.to(modalOuter.get(0), 0.5, { delay: 0.2, opacity: 1 });
        }
    };

    const hide = () => {
        if (!modalHidden) {
            modalHidden = true;
            TweenMax.to(modal.get(0), 0.3, { delay: 0.5, opacity: 0, clearProps: 'all' });
            TweenMax.to(modalOuter.get(0), 0.5, { opacity: 0 });
        }
    };

    const keyup = e => {
        const key = e.keyCode || e.which;

        if (key === 27 && !modalHidden) {
            hide();
        }
    };

    const resizeBackground = () => {
        modalItems.each(item => {
            const img = $(item).find('img');
            const width = img.width();
            const height = img.height();
            const containerAspect = width / height;
            const imageAspect = $(item).data('aspect');
            let maxHeight;

            if (imageAspect >= containerAspect) {
                maxHeight = width / imageAspect;
            } else {
                maxHeight = height;
            }

            $(item).find('[data-modal-bg]').css('height', `${maxHeight}px`);
        });
    };

    const onCloseClick = e => {
        e.preventDefault();

        hide();
    };

    const initSlider = index => {
        dom.append(`
            <div class="gallery__modal fs-15 fs-18@m fs-23@xl pos-f d-n u-fill z-9999" data-modal>
                <div class="pos-a d-f u-fill" data-modal-outer>
                    <div class="u-wrap d-f w-100">
                        <div class="gallery__modal-inner w-100" data-modal-inner><a href="#top" class="fw-700 gallery__modal-close" data-modal-close>Lukk</a></div>
                    </div>
                </div>
            </div>`);

        modalImages.addClass('gallery__modal-image u-objectfit u-objectfit--contain pos-r z-2');

        modal = dom.find('[data-modal]');
        modalOuter = dom.find('[data-modal-outer]');
        modalInner = dom.find('[data-modal-inner]');
        modalInner.append(modalImages);

        modalClose = dom.find('[data-modal-close]');
        modalClose.on('click', onCloseClick);

        modalImages.wrap('<div class="d-f fd-c w-100 h-100 pb-70 " data-modal-item></div>').wrap('<div class="gallery__modal-image-wrap overflow-h u-wrap w-100 pos-r h-100 flex-11" data-image-wrap></div>');

        modalItems = modal.find('[data-modal-item]');

        modalItems.each((item, i) => {
            const color = $(items.get(i)).data('bg');
            const caption = $(items.get(i)).data('caption');
            $(item).data('aspect', $(items.get(i)).data('aspect'));
            $(item).prepend(`
                <div class="fw-700 gallery__caption ta-c u-ptb-50 u-wrap flex-00">
                    <span class="d-n">${caption}</span>&nbsp;
                </div>`);
            if (color.length) {
                $(item).find('[data-image-wrap]').append(`<div class="gallery__modal-bg pos-a u-fill z-1" data-modal-bg style="background: ${color};"></div>`);
            }
        });

        hasModal = true;

        loadFlickity(Flickity => {
            flkty = new Flickity(modalInner.get(0), {
                cellSelector: '[data-modal-item]',
                wrapAround: false,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                draggable: true,
                dragThreshold: 10,
                cellAlign: 'center',
                setGallerySize: false,
                percentPosition: true,
                accessibility: true,
                initialIndex: index
            });

            flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
                if (flkty.selectedIndex !== cellIndex) {
                    flkty.select(cellIndex, false, false);
                }
            });
            
            show();
            flkty.resize();
            resizeBackground();
        });

    };

    const onClick = e => {
        const node = e.triggerTarget;
        const index = items.index(node);

        if (typeof flkty === 'undefined') {
            initSlider(index);
        } else if (modalHidden) {
            flkty.select(index, false, true);
            show();
            flkty.resize();
        }
    };

    const onResize = () => {
        if (hasModal) {
            resizeBackground();
        }
    };

    const init = () => {
        debouncedResize = debounce(onResize, 500);
        Viewport.on('resize', debouncedResize);
        loadMasonry(Masonry => {
            msnry = new Masonry(el, {
                itemSelector: '[data-item]',
                columnWidth: '[data-spacer]',
                percentPosition: true,
                gutter: 0,
                transitionDuration: 0.1
            });
        });

        items.on('click', onClick);
        document.addEventListener('keyup', keyup);
    };

    const destroy = () => {
        Viewport.off('resize', debouncedResize);
        msnry.destroy();
        document.removeEventListener('keyup', keyup);

        if (modalClose.length) {
            modalClose.off('click', onCloseClick);
        }
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Gallery.js